export default "__VITE_ASSET__DOcxheY$__"